import type { RemoveIndexSignature } from 'src/types/removeIndexSignature';

import { ComposerTranslation, LocaleMessageValue, VueMessageType } from 'vue-i18n';

import { Directory } from '@capacitor/filesystem';
import writeBlob from 'capacitor-blob-writer';
import { useLoadingStore } from 'src/stores/loading';

import { notifyService } from 'src/services/notify/NotifyService';

import { Callback } from 'src/util/query/models/Callback';

export class GetTheTheDocumentQueryCallback extends Callback<Blob> {
	private readonly filename: string;
	private readonly t: ComposerTranslation<
		{
			[p: string]: LocaleMessageValue<VueMessageType>;
		},
		string,
		RemoveIndexSignature<{
			[p: string]: LocaleMessageValue<VueMessageType>;
		}>,
		never,
		string,
		string
	>;

	constructor(
		filename: string,
		t: ComposerTranslation<
			{
				[p: string]: LocaleMessageValue<VueMessageType>;
			},
			string,
			RemoveIndexSignature<{
				[p: string]: LocaleMessageValue<VueMessageType>;
			}>,
			never,
			string,
			string
		>
	) {
		super();
		this.filename = filename;
		this.t = t;
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Blob): void => {
		useLoadingStore().hide();

		void writeBlob({
			blob: successResponse,
			directory: Directory.Documents,
			fast_mode: true,
			on_fallback(error) {
				console.error(error);
			},
			path: this.filename,
			recursive: false,
		}).then(() => {
			notifyService.success(this.t('document_download_to_documents_successful'));
		});
	};
}
